module.exports = __webpack_public_path__ + "static/media/icon-amazon.4e2817a0.svg";